// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"footer_footerContainer__RigLd","footerAboutRentSpree":"footer_footerAboutRentSpree__X5c6a"};